import { createAction, props } from '@ngrx/store';
import { Requirement } from '../../../model/jira/release-item';
import { TraceabilityDetail } from '../../../model/traceability/traceability-detail';

export const loadPipelineRequirements = createAction(
  `[Regression Test] Trigger loading of pipeline requirements from JIRA`,
  props<{ pipelineId: string }>(),
);

export const loadPipelineRequirementsError = createAction(
  `[Regression Test] Loading pipeline requirements from JIRA failed`,
  props<{ pipelineId: string }>(),
);

export const setPipelineRequirements = createAction(
  `[Regression Test] Set pipeline requirements from JIRA`,
  props<{ pipelineId: string; requirements: Requirement[] }>(),
);

export const loadPipelineRunRegressionTests = createAction(
  `[Regression Test] Trigger loading of pipeline run regression tests from backend`,
  props<{ pipelineId: string; pipelineRunId: number }>(),
);

export const loadPipelineRunRegressionTestsError = createAction(
  `[Regression Test] Loading pipeline run regression tests from backend failed`,
  props<{ pipelineRunId: number }>(),
);

export const setPipelineRunRegressionTests = createAction(
  `[Regression Test] Set pipeline run regression tests from backend`,
  props<{ pipelineRunId: number; pipelineRunRegressionTests: TraceabilityDetail[] }>(),
);

export const missingDeliveryFixVersionError = createAction(
  `[Regression Test] Missing DeliveryFixVersion Error`,
  props<{ pipelineId: string }>(),
);
